module.exports = __webpack_public_path__ + "static/media/brand-square.3757b83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/brand-square.jpg
// module id = 491
// module chunks = 0